<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a class="ui_close" type="button" @click="close"><span class="sr_only"></span></a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('SUBTITLE.USER.MANAGEMENT.DETAIL') }}</i>
                    </dt>
                    <dd>
                        <table class="create_table">
                            <colgroup>
                                <col width="290px" />
                                <col class="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.ID') }}({{ $t('BUTTON.GLOBAL.EMAIL') }})</th>
                                    <td>{{ data.email }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.PROFILE.COMPANY.NAME') }}</th>
                                    <td>{{ data.companyName }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.COMPANY.REGISTRATION.NUMBER') }}</th>
                                    <td>{{ data.companyRegNo }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.EUR.COMP.ADDR') }}</th>
                                    <td>{{ data.companyAddress }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.POSTAL.CODE') }}</th>
                                    <td>{{ data.zipCode }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.COMPANY.WEBSITE.ADDRESS') }}</th>
                                    <td>{{ data.companyWebAddress }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.EUR.FIRST.NAME') }}</th>
                                    <td>{{ data.contactFirstName }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.EUR.LAST.NAME') }}</th>
                                    <td>{{ data.contactLastName }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.CONTACT.PHONE.NUMBER') }}</th>
                                    <td>{{ data.phoneNumber }}</td>
                                </tr>
                                <tr v-if="'C480' === corpCd">
                                    <th>{{ $t('FIELD.EUR.APE.CODES') }}</th>
                                    <td>{{ data.apeCodes }}</td>
                                </tr>
                                <tr v-if="0 < parseInt(data.fileLength1)">
                                    <th>{{ $t('FIELD.INSURANCE.POLICY') }}</th>
                                    <td>
                                        <a
                                            href="javascript:"
                                            class="link_attch"
                                            @click="downloadFile('1', data.fileName1)"
                                        >
                                            <span class="ico_attach"></span>{{ data.fileName1 }}
                                        </a>
                                    </td>
                                </tr>
                                <tr v-if="0 < parseInt(data.fileLength2)">
                                    <th>{{ $t('FIELD.COMPANY.REGISTRATION.FILE') }}</th>
                                    <td>
                                        <a
                                            href="javascript:"
                                            class="link_attch"
                                            @click="downloadFile('2', data.fileName2)"
                                        >
                                            <span class="ico_attach"></span>{{ data.fileName2 }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'RequestVocUserInfoPopup',
    props: {
        data: { type: Object, default: {} },
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
        }),
    },
    data() {
        return {
            fileName1: '',
            fileName2: '',
        };
    },
    methods: {
        close() {
            this.attachFileClear();
            this.$emit('close');
        },
        downloadFile(fileType, fileName) {
            if ('1' === fileType) {
                this.fileName1 = fileName;
            } else if ('2' === fileType) {
                this.fileName2 = fileName;
            } else {
                return false;
            }

            let url = `${SDLUtil.API_URL}/noauth/eur/getAttachFileInfo.skp`;
            let params = {
                fileType: fileType,
                bpNo: this.data.bpNo,
            };
            axios
                .post(url, qs.stringify(params))
                .then(resp => {
                    let downloadLink = document.createElement('a');
                    downloadLink.download = fileName;
                    downloadLink.target = '_blank';
                    downloadLink.href = resp.data.fileDownUrl;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        attachFileClear() {
            let url = `${SDLUtil.API_URL}/noauth/eur/clearAttachFiles.skp`;
            let fileName = this.fileName1;
            if (!SDLUtil.isNull(this.fileName2)) {
                if (SDLUtil.isNull(fileName)) {
                    fileName = this.fileName2;
                } else {
                    fileName += ',' + this.fileName2;
                }
            }
            axios
                .post(url, qs.stringify({ fileNames: fileName }))
                .then(resp => {})
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
    },
    mounted() {},
    beforeDestroy() {
        this.attachFileClear();
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/voc/RequestVocUserInfoPopup.vue